import { useAppSelector, userPermissionCheck } from '@monorepo/shared';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';
import { CSSProperties, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Stack } from 'rsuite';
import { AssetList } from './AssetList';
import { InstanceList } from './InstanceList';
import { HomeElms } from '../../config/const';
import BlockIcon from '@rsuite/icons/Block';
import { use } from 'i18next';

export const AccountDetail = () => {
  const { groupId } = useParams();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const [account, setAccount] = useState<Record<string, any>>({});
  const [isAuth, setIsAuth] = useState<boolean>(true);
  useEffect(() => {
    if (currentAccount?.account_id) {
      const region = currentAccount?.region || [];
      const regionArr = Array.isArray(region) ? region : [region];
      setAccount({
        ...currentAccount,
        regionStr: Array.from(
          new Set(
            regionArr.map((obj: Record<string, any>) => {
              return [obj.name, obj.alias].join('|');
            })
          )
        )
      });
      const isAuthPassed =
        !!groupId || userPermissionCheck(currentAccount, HomeElms?.fcName);
      setIsAuth(isAuthPassed);
    }
  }, [currentAccount]);

  useEffect(() => {
    if (!isAuth && currentAccount?.account_id) {
      if (currentAccount?.user_auth_url) {
        console.info(
          'Account does not have permission, redirecting to user auth URL...',
          currentAccount.user_auth_url
        );
        window.location.href = currentAccount.user_auth_url;
      }
    }
  }, [isAuth, currentAccount]);

  return (
    <div className="account-detail-container">
      {isAuth ? (
        <>
          <div className="grid-container row">
            {/* account information */}
            <div className="grid-item account-info ">
              <div className="grid-header">
                <div className="title">
                  <i className="icon-fortinetone-productList"></i>
                  Account Information
                </div>
              </div>
              <div className="grid-content">
                <div className="info-list">
                  {Object.keys(account)
                    .filter((key) => Object.keys(accountCols).includes(key))
                    .map((key: string, index: number) => {
                      return (
                        <Stack
                          key={index}
                          alignItems="flex-start"
                          style={{ marginBottom: '5px' }}
                        >
                          <Stack.Item className="list-type">
                            {accountCols[key]}
                          </Stack.Item>
                          <Stack.Item className="list-content" grow={1}>
                            {key === 'regionStr' &&
                            Array.isArray(account[key]) ? (
                              <ul style={{ paddingLeft: '14px' }}>
                                {account[key]?.map(
                                  (value: string, index: number) => {
                                    const arr = value?.split('|');
                                    const alias = arr[1] || '';
                                    const name = arr[0] || '';
                                    return (
                                      <li key={index}>
                                        <Link
                                          key={index}
                                          to={`region/${alias}`}
                                        >
                                          {name}
                                        </Link>
                                      </li>
                                    );
                                  }
                                )}
                              </ul>
                            ) : (
                              <>{account[key]}</>
                            )}
                          </Stack.Item>
                        </Stack>
                      );
                    })}
                </div>
              </div>
            </div>
            <AssetList />
          </div>
          <div className="grid-container">
            <InstanceList />
          </div>
        </>
      ) : (
        <div
          className="no-auth-content"
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          <div>
            <BlockIcon color="red" style={{ fontSize: '2em' }} />
          </div>

          <div className="no-auth-title">
            {
              'Current selected account does not have permission to view the content'
            }
          </div>
          {account?.user_auth_url && (
            <Button appearance="primary" href={account.user_auth_url}>
              Go To Support Page
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

const accountCols: Record<string, string> = {
  account_company: 'Company',
  account_id: 'Account ID',
  master_user_name: 'Owner',
  account_name: 'Account Name',
  account_email: 'Account Email',
  regionStr: 'Service Regions'
};

export const styleCenter: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export const flexColumn: CSSProperties = {
  ...styleCenter,
  flexDirection: 'column'
};

export const styleCenterWithHeight: CSSProperties = {
  ...styleCenter,
  height: '60px'
};

export const columnLeft: CSSProperties = {
  ...flexColumn,
  alignItems: 'flex-start'
};
export const columnLeftWithHeight: CSSProperties = {
  ...columnLeft,
  height: '60px',
  overflow: 'hidden'
};

export const slimText: CSSProperties = {
  fontSize: '10px',
  opacity: 0.9,
  fontWeight: '400',
  paddingBottom: 5,
  overflow: 'hidden',
  whiteSpace: 'nowrap'
};

export const titleStyle: CSSProperties = {
  // paddingBottom: 5,
  whiteSpace: 'nowrap'
};

export const dataStyle: CSSProperties = {
  fontSize: '12px',
  fontWeight: 500,
  overflow: 'hidden',
  whiteSpace: 'nowrap'
};

export const textStyle: CSSProperties = {
  fontSize: '16px',
  fontWeight: 500
};
export const subTitleStyle: CSSProperties = {
  paddingBottom: 5,
  whiteSpace: 'nowrap',
  fontWeight: 400,
  fontSize: '0.8em',
  opacity: 0.8
};
